export enum EntityStatus {
  Operating = 'Operating',
  NotOperating = 'Not_Operating',
}

export enum EntityLevel {
  HoldingCompany = 'Group',
  Subsidiary = 'Entity_Level',
}

export enum EntityType {
  HoldingCompany = 'Holding_Company',
  Subsidiary = 'Subsidiary',
}

export enum StatementStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}

export enum Department {
  HUMAN_RESOURCE = 'HUMAN_RESOURCE',
  IT_SUPPORT = 'IT_SUPPORT',
  MARKETING = 'MARKETING',
}

export enum CommencementStatus {
  New = 'New',
  Planned = 'Planned',
  Operational = 'Operational',
}

export enum FrequencyOfMeasurement {
  Monthly = 'Monthly',
  Quarterly = 'Quarterly',
  BiAnnually = 'Bi-annually',
  Annually = 'Annually',
}

export enum ResourceRequirements {
  Time = 'Time',
  HumanCapitalRequired = 'Human_Capital_Required',
  FinancialResourcesNeeded = 'Financial_Resources_Needed',
  TeamCompositionStructure = 'Team_Composition_Structure',
  OverlapSupport = 'Overlap_Support',
  Enablers = 'Enablers',
}

export enum ReportStatus {
  ACHIEVED = 'ACHIEVED',
  ON_TRACK = 'ON_TRACK',
  AT_RISK = 'AT_RISK',
  AHEAD = 'AHEAD',
  BEHIND = 'BEHIND',
  NOT_STARTED = 'NOT_STARTED',
}

export enum ApprovalStatus {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  ARCHIVED = 'ARCHIVED',
}

export enum ActionVerb {
  Increase = 'Increase',
  Decrease = 'Decrease',
  Maintain = 'Maintain',
}

export enum UnitOfMeasurement {
  Percentage = 'Percentage',
  Amount = 'Amount',
}
